module.exports = __webpack_public_path__ + "img/gifting-reminder-vase.c49c7881.svg";